import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Sidebar from "./Sidebar";
import Header from "./Header";
import SubHeader from "./SubHeader";
import "../Style/PdfGuideLineList.css";
import { BASE_URL } from "../Apis/apiConfig";

export default function PdfGuideLineList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [notes, setNotes] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = localStorage.getItem("token");

  const fetchData = async () => {
    try {
      setLoading(true);
      const societyName = localStorage.getItem("society");
      const res = await axios.post(
        `${BASE_URL}/society-setting/get-society-setting`,
        null,
        {
          params: { societyName },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ---------------- DELETE ----------------
 const handleDelete = async (id) => {
  if (!window.confirm("Delete this guideline?")) return;

  try {
    await axios.delete(
      `${BASE_URL}/society-setting/society/${id}`, // ✅ FIXED URL
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    toast.success("Deleted successfully");
    fetchData();
  } catch (err) {
    console.error(err);
    toast.error("Delete failed");
  }
};

  // ---------------- OPEN EDIT ----------------
 const handleEdit = (item) => {
  setEditItem(item);
  setShowModal(true);

  const text = item.notes?.map((n) => n.note).join("\n") || "";
  setNotes(text);
};

const closeModal = () => {
  setShowModal(false);
  setEditItem(null);
  setNotes("");
};

  // ---------------- UPDATE ----------------
const handleUpdate = async () => {
  try {
    if (!editItem) return;
    const payload = {
      societySettingId: editItem.societySettingId,
      societyName: editItem.societyName,
      notes: notes
        .split("\n")
        .map((n) => n.trim())
        .filter((n) => n !== "")
        .map((n) => ({
          note: n,
        })),
    };

    await axios.put(
      `${BASE_URL}/society-setting/update-society-setting/${editItem.societySettingId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Updated successfully");

    closeModal();
    fetchData();

  } catch (err) {
    console.error(err);
    toast.error(err?.response?.data?.message || "Update failed");
  }
};
  return (
    <div className="app-container">
      <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <main className="content-area">
          <SubHeader />
          <div className="page">
            <h2 className="pageTitle">Society Guidelines</h2>

            {loading ? (
              <div className="loader">Loading...</div>
            ) : data.length === 0 ? (
              <div className="emptyState">No guidelines found</div>
            ) : (
              data.map((item) => (
                <div key={item.societySettingId} className="cardBox">

                  <div className="cardTop">
                    <span className="idBadge">#{item.societySettingId}</span>

                    <div className="right">
                    <button className="editBtn" onClick={() => handleEdit(item)}>
                      Edit
                    </button>

                      <button className="deleteBtn"  onClick={() => handleDelete(item.societySettingId)} > Delete</button>
                    </div>
                  </div>

                  <div className="notesSection">
                    {item.notes?.length > 0 ? (
                      item.notes.map((note, i) => (
                        <div key={note.societyNoteId} className="noteRow">
                          <span className="noteNo">{i + 1}</span>
                          <span className="noteText">{note.note}</span>
                        </div>
                      ))
                    ) : (
                      <div className="noNotes">No notes available</div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </main>
      </div>

      {showModal && editItem && (
       <div className="modalOverlay">
        <div className="modalBox">

          <div className="modalHeader">
            <h3>Edit Society Guidelines</h3>
            <button onClick={closeModal} className="closeBtn">✖</button>
          </div>

          <textarea
            className="textarea"
            rows="10"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter each guideline in new line"
          />

          <div className="modalActions">
            <button className="saveBtn" onClick={handleUpdate}>
              Save Changes
            </button>

            <button className="cancelBtn" onClick={closeModal}>
              Cancel
            </button>
          </div>
        </div>
      </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}